/** @typedef {string} ButtonDisplayType */
export const BUTTON_DISPLAY_TYPE_NONE = 'none';
export const BUTTON_DISPLAY_TYPE_SOLID = 'solid';
export const BUTTON_DISPLAY_TYPE_TRANSPARENT = 'transparent';
/** @enum {ButtonDisplayType} */
export const BUTTON_DISPLAY_TYPE = {
	NONE: BUTTON_DISPLAY_TYPE_NONE,
	SOLID: BUTTON_DISPLAY_TYPE_SOLID,
	TRANSPARENT: BUTTON_DISPLAY_TYPE_TRANSPARENT
};
/** @type {ButtonDisplayType[]} */
export const BUTTON_DISPLAY_TYPES = [
	BUTTON_DISPLAY_TYPE_NONE, 
	BUTTON_DISPLAY_TYPE_SOLID, 
	BUTTON_DISPLAY_TYPE_TRANSPARENT
];

/** @typedef {string} ButtonStyle */
export const BUTTON_STYLE_NONE = 'none';
export const BUTTON_STYLE_DEFAULT = 'default';
export const BUTTON_STYLE_HIGHLIGHT = 'highlight';
export const BUTTON_STYLE_SUBTLE = 'subtle';
export const BUTTON_STYLE_ACTION = 'action';
export const BUTTON_STYLE_SUCCESS = 'success';
export const BUTTON_STYLE_WARNING = 'warning';
export const BUTTON_STYLE_ERROR = 'error';
export const BUTTON_STYLE_INFO = 'info';
/** @enum {ButtonStyle} */
export const BUTTON_STYLE = {
	NONE: BUTTON_STYLE_NONE,
	DEFAULT: BUTTON_STYLE_DEFAULT,
	HIGHLIGHT: BUTTON_STYLE_HIGHLIGHT,
	SUBTLE: BUTTON_STYLE_SUBTLE,
	ACTION: BUTTON_STYLE_ACTION,
	SUCCESS: BUTTON_STYLE_SUCCESS,
	WARNING: BUTTON_STYLE_WARNING,
	ERROR: BUTTON_STYLE_ERROR,
	INFO: BUTTON_STYLE_INFO,
};
/** @type {ButtonStyle[]} */
export const BUTTON_STYLES = [
	BUTTON_STYLE_NONE, 
	BUTTON_STYLE_DEFAULT, 
	BUTTON_STYLE_HIGHLIGHT,
	BUTTON_STYLE_SUBTLE, 
	BUTTON_STYLE_ACTION, 
	BUTTON_STYLE_SUCCESS, 
	BUTTON_STYLE_WARNING, 
	BUTTON_STYLE_ERROR,
	BUTTON_STYLE_INFO,
];